import { IFtthOffer } from "@nju/data-access-portal-offers";
import { Icon, IconName } from "@nju/icons";
import { IconListElement, Separator, Text, Tooltip } from "@nju/ui";

interface ISidebarFtthOfferBenefits {
  installationPrice: string;
  benefits: IFtthOffer["shortFeatures"];
  bundleDiscount?: number;
  isReactivationProcess: boolean;
}

export function SidebarFtthOfferBenefits({
  installationPrice,
  benefits,
  bundleDiscount,
  isReactivationProcess,
}: ISidebarFtthOfferBenefits) {
  return (
    <>
      <div>
        <Text>w ofercie masz:</Text>
        {benefits.map((benefit, index) => {
          return (
            <IconListElement
              iconName={benefit.icon as IconName}
              iconSize="big"
              key={index}
              mode="markdown"
              text={benefit.description.pl}
            />
          );
        })}
      </div>
      {bundleDiscount && (
        <div className="border-1 border-cerulean border-dashed rounded-[12px] px-3 mt-1">
          <IconListElement
            iconAlign="start"
            iconName="badge-percent"
            iconSize="medium"
            mode="raw"
            text={`W pakiecie taniej - jeśli masz już aktywną usługę nju subskrypcja, zapłacisz za nią o ${bundleDiscount} zł mniej miesięcznie.`}
          />
        </div>
      )}
      {!isReactivationProcess && (
        <>
          <Separator size="s" thickness="medium" />
          <Text>opłata jednorazowa:</Text>
          <IconListElement
            iconName="wallet"
            iconSize="big"
            mode="raw"
            text={`${installationPrice} zł za instalację usługi`}
          />
          <div className="flex items-center gap-1">
            <IconListElement
              iconName="wallet"
              iconSize="big"
              mode="raw"
              text="0 zł za opłatę aktywacyjną"
            />
            <Tooltip content="opłata uwzględnia zniżkę za wyrażenie zgód marketingowych (zniżka 20 zł)">
              <Icon height={17} name="info-circle" width={17} />
            </Tooltip>
          </div>
        </>
      )}
    </>
  );
}
